import { Button } from '@progress/kendo-react-buttons'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { Card, CardBody, CardHeader, CardTitle, GridLayout, GridLayoutItem, StackLayout } from '@progress/kendo-react-layout'

import './Auth.css'

const branchNames = ['A会社', 'B会社']

const department = ['調達本部 第一調達', '横浜調達部', '千葉調達部', '関東調達部', '関西調達部', '中国調達部', '四国調達部']

const auth = ['工務担当者', '建材部担当者', '支店担当者', '業者']

export default function AuthSearch() {
  return (
    <div>
      <Card style={{ margin: 20 }}>
        <CardHeader>
          <CardTitle>権限</CardTitle>
        </CardHeader>
        <CardBody>
          <GridLayout>
            <GridLayoutItem col={1} row={1} className="grid-layout-item-title">
              管理会社
            </GridLayoutItem>
            <GridLayoutItem col={1} row={2}>
              <DropDownList data={branchNames} defaultValue={'A会社'} disabled />
            </GridLayoutItem>

            <GridLayoutItem col={2} row={1} className="grid-layout-item-title">
              部署
            </GridLayoutItem>
            <GridLayoutItem col={2} row={2}>
              <DropDownList data={department} defaultValue={'調達本部 第一調達'} disabled />
            </GridLayoutItem>

            <GridLayoutItem col={3} row={1} className="grid-layout-item-title">
              権限
            </GridLayoutItem>
            <GridLayoutItem col={3} row={2}>
              <DropDownList data={auth} defaultValue={'工務担当者'} />
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
      </Card>

      <StackLayout gap={5} align={{ horizontal: 'end' }}>
        <Button themeColor="primary" className="pcy-button-long">
          登録/修正
        </Button>
        <Button className="pcy-button-long">戻る</Button>
      </StackLayout>
    </div>
  )
}
